<template>
	<div class="setting">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 text-gray mt-3 mt-md-0">
					<ml-menu></ml-menu>

					<div class="col-12 p-0 pb-3">
						<div class="container p-0 p-md-2">
							<div class="row">
								<div class="col-6 col-md-6 mt-5 mt-md-5">
									<div class="col-md-12 d-md-flex pl-0 mt-2">
										<h4>Profile</h4>
									</div>
								</div>
								<div class="col-6 pr-0 col-md-6 mt-5 mt-md-5 d-none d-sm-block">
									<nav aria-label="breadcrumb">
										<ol class="breadcrumb float-right">
											<li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
											<li class="breadcrumb-item active" aria-current="page"><a href="javascript:;">Profile</a></li>
										</ol>
									</nav>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-md-12 col-lg-8">
									<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-4 col-md-4 font-size-sm-11">
														<p>Data Profile</p>
													</div>
													<div class="col-8 col-md-8 mt-n1 pr-4">
														<BtnShareStore @success="$refs.suksesCopyLink.modalShow()" v-if="false"></BtnShareStore>
														<button v-if="showChangeProfile" class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right box-purple mr-2" @click="UbahProfile()"><img src="assets/icon/edit.png" class="img-fluid pr-1">Ubah Profile</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pl-4 pb-4 pr-0">
											<div class="col-12 p-0 font-size-10 font-size-sm-9">
												<div class="row">
													<div class="col-md-6">
														<div class="row">
															<div class="col-4 col-md-4 pt-1 pl-3 pr-1">
																<div class="image-frame cus-box-shadow">
																	<img :src="profile.stockist_image">
																</div>
																<div class="ml-3 mt-n1">
																	<button class="mt-n4 ml-5 btn btn-sm btn-mila rounded-full position-absolute box-purple" @click="ubahFoto()"><img src="assets/icon/kamera.png" class="img-fluid mt-n1"></button>  
																</div>
															</div>
															<div class="col-6 col-md-6 pl-1 pt-3 pr-4 pr-md-0">
																<div><img src="assets/icon/nama.png" class="img-fluid pr-1 mb-1"> {{profile.stockist_name}}</div>
																<div class="pt-1"><img src="assets/icon/kode_member.png" class="img-fluid pr-1 mb-1">{{ profile.stockist_network_mid}}</div>
																<div class="pt-1"><img src="assets/icon/phone.png" class="img-fluid pr-1 mb-1">{{ profile.stockist_mobilephone}}</div>
															</div>
															<div class="col-1 col-md-1 pr-0 pl-0 ml-n3">
															</div>
														</div>
														<div class="row pt-4">
															<div class="col-4 col-md-3 pl-2 pr-3 mr-n1 pr-md-0 d-flex">
																<div class="btn-purple btn-sm text-white rounded font-size-9 btn-block text-center justify-content-between">
																	<img src="assets/icon/member.png" class="img-fluid pr-1">
																	<br>{{ profile.stockist_is_active == 1 ? 'AKTIF' : 'TIDAK AKTIF'}}
																</div>
															</div>
															<div class="col-4 col-md-3 pl-2 pr-3 mr-n1 pr-md-0 d-flex">
																<div class="btn-purple btn-sm text-white rounded font-size-9 btn-block text-center justify-content-between" style="text-transform:uppercase">
																	<img src="assets/icon/toko.png" class="img-fluid pr-1">
																	<br>{{ profile.stockist_close_status == 'open' ? 'Toko Buka' : 'Toko Tutup' }}
																</div>
															</div>
															<div class="col-4 col-md-3 pl-2 pr-3 mr-n1 pr-md-0 d-flex">
																<div class="btn-purple btn-sm text-white rounded font-size-9 btn-block text-center justify-content-between" style="text-transform:uppercase">
																	<img src="assets/icon/keranjang.png" class="img-fluid pr-1">
																	<br>{{ profile.stockist_order_count}} Order
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-6 pl-1 pl-md-0 pr-4 ml-n2 pt-4 pt-md-0">
														<div class="row">
															<div class="col-4 col-md-3 pr-0 pt-md-3 ml-3 ml-md-0">
																<div>Waktu Input</div>
																<div class="pt-1">Kode</div>
																<div class="pt-1">Email</div>
																<div class="pt-1">Alamat</div>
															</div>
															<div class="col-1 col-md-1 pr-0 pt-md-3">
																<div>:</div>
																<div class="pt-1">:</div>
																<div class="pt-1">:</div>
																<div class="pt-1">:</div>
															</div>
															<div class="col-6 col-md-8 pl-2 pr-0 pr-md-3 pt-md-3 ml-md-n2 pb-2">
																<div>{{ profile.stockist_input_datetime | tanggaljam }}</div>
																<div class="pt-1">{{ profile.stockist_code }}</div>
																<div class="pt-1" v-if="!profile.stockist_email"> - </div>
																<div class="pt-1" v-else>{{ profile.stockist_email }}</div>
																<div class="pt-1">{{ profile.stockist_origin_address }}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- alamat -->
								<div class="col-12 col-md-12 col-lg-4 mt-3 mt-md-3 mt-lg-0">
									<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-6 col-md-6 pr-0 font-size-sm-11">
														<p>Alamat</p>
													</div>
													<div class="col-6 col-md-6 mt-n1 pr-4">
														<button v-if="showEditAddress" class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right box-purple" @click="ubahAlamat()"><img src="assets/icon/edit.png" class="img-fluid pr-1">Ubah Alamat</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pl-4 pb-4 pr-0">
											<div class="col-12 p-0 pb-md-3 mt-md-2 font-size-10 font-size-sm-9">
												<div class="row">
													<div class="col-5 col-md-3 col-lg-5 pt-2">
														<div>Provinsi</div>
														<div class="pt-1">Kota/Kabupaten</div>
														<div class="pt-1">Kecamatan</div>
														<div class="pt-1">Alamat Lengkap</div>
													</div>
													<div class="col-1 col-md-1 pl-0 pr-0 pt-2">
														<div>:</div>
														<div class="pt-1">:</div>
														<div class="pt-1">:</div>
														<div class="pt-1">:</div>
													</div>
													<div class="col-6 col-md-6 pl-0 pr-4 ml-n2 ml-lg-n2 ml-md-n5 pt-2">
														<div>{{ profile.stockist_origin_province_name }}</div>
														<div class="pt-1">{{ profile.stockist_origin_city_name}}</div>
														<div class="pt-1">{{ profile.stockist_origin_subdistrict_name}}</div>
														<div class="pt-1">{{ profile.stockist_origin_address}}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-12 col-lg-8 mt-3">
									<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-6 col-md-6 font-size-sm-11">
														<p>Jam Operasional</p>
													</div>
													<div class="col-6 col-md-6 mt-n1 pr-4">
														<button v-if="profile.stockist_close_status == 'open'" class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right box-purple" @click="tutupToko()"><i class="far fa-calendar mr-2 font-size-9"></i>Tutup Toko</button>
														<button v-else class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right box-purple" @click="konfirmasiBuka()"><i class="far fa-calendar mr-2 font-size-9"></i>Buka Toko</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 d-flex pt-4 pl-4 pb-4">
											<div class="col-12 p-0 font-size-10 font-size-sm-9">
												<div class="row" v-if="Object.keys(scedule).length > 0">
													<div class="col-md-6">
														<div class="row">
															<div class="col-3">Senin</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.senin.open || scedule.senin.close" @input="ubahJadwalToko('senin')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.senin == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.senin.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.senin.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="row pt-4">
															<div class="col-3">Selasa</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.selasa.open || scedule.selasa.close" @input="ubahJadwalToko('selasa')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.selasa == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.selasa.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.selasa.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="row pt-4">
															<div class="col-3">Rabu</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.rabu.open || scedule.rabu.close" @input="ubahJadwalToko('rabu')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.rabu == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.rabu.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.rabu.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="row pt-4">
															<div class="col-3">Kamis</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.kamis.open || scedule.kamis.close" @input="ubahJadwalToko('kamis')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.kamis == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.kamis.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.kamis.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
													</div>
													<div class="col-md-6 ">
														<div class="row pt-4 pt-md-0">
															<div class="col-3">Jumat</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.jumat.open || scedule.jumat.close" @input="ubahJadwalToko('jumat')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.jumat == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.jumat.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.jumat.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="row pt-4">
															<div class="col-3">Sabtu</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.sabtu.open || scedule.sabtu.close" @input="ubahJadwalToko('sabtu')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.sabtu == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.sabtu.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.sabtu.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
														<div class="row pt-4">
															<div class="col-3">Minggu</div>
															<div class="col-2 pl-0">
																<label class="switch switch-sm">
																	<input type="checkbox" :checked="scedule.minggu.open || scedule.minggu.close" @input="ubahJadwalToko('minggu')">
																	<span class="slider round"></span>
																</label>
															</div>
															<div v-if="scedule.minggu == ''" class="col-7">Tutup</div>
															<div v-else class="col-7 d-flex mt-n2">
																<div class="col-5 p-0">
																	<select v-model = "scedule.minggu.open" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
																<div class="col-2 pt-2 pl-0 pr-0 text-center">
																	-
																</div>
																<div class="col-5 p-0">
																	<select v-model = "scedule.minggu.close" class="form-control font-size-10 box-purple" @change="updateScedule(scedule)">
																		<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
																	</select>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="row" v-if="profile.stockist_close_status == 'close'">
													<div class="col-12 pt-4">
														<div class="col-12 background-purple-light rounded pt-4 pb-4 pl-0 pl-md-3">
															<div class="col-12 font-size-13 font-size-sm-11">Jadwal Libur / Jadwal Toko Tutup</div>
															<div class="col-12 pt-3 d-md-flex">
																<div><i class="far fa-calendar-alt text-purple mr-3"></i>{{profile.stockist_close_start_datetime}}</div>
																<div><span class="pr-1 pr-md-2 pl-4 pl-md-2">Sampai</span>{{profile.stockist_close_end_datetime}}</div>
															</div>
															<div class="col-12 pt-3">
																<div><i class="far fa-edit text-purple mr-3"></i>{{profile.stockist_close_reason}}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-12 col-lg-4 mt-3 mt-md-3">
									<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-6 col-md-6 pr-0 font-size-sm-11">
														<p> Data Bank</p>
													</div>
													<div class="col-6 col-md-6 mt-n1 pr-4" v-if="showEditBank">
														<button class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right box-purple" @click="UbahBank()"><img src="assets/icon/edit.png" class="img-fluid pr-1">Ubah Bank</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pl-4 pb-4 pr-0">
											<div class="col-12 p-0 pb-md-3 mt-md-2 font-size-10 font-size-sm-9">
												<div class="row">
													<div class="col-5 col-md-5 col-lg-5 pt-2">
														<div>Nama Bank</div>
														<div class="pt-1">Nomor Rekening</div>
														<div class="pt-1">Nama Pemilik </div>
													</div>
													<div class="col-1 col-md-1 pl-0 pr-0 pt-2">
														<div>:</div>
														<div class="pt-1">:</div>
														<div class="pt-1">:</div>
													</div>
													<div class="col-6 col-md-6 pl-0 pr-4 ml-n2 ml-lg-n2 ml-md-n5 pt-2">
														<div>{{ bank.bank_name }}</div>
														<div class="pt-1">{{ bank.account_number }}</div>
														<div class="pt-1">{{ bank.account_name }}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<VModal ref="updateAlamat" type="modal-xl">
			<template v-slot:title>
				Ubah Alamat
			</template>
			<template v-slot:body class="font-size-11">
				<div class="container-fluid font-size-11 font-size-sm-10 pl-0 pr-0 pl-lg-3 pr-lg-3 pb-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
						<div class="order-1 order-lg-0 col-12 col-lg-6 pl-0 pr-0 pl-lg-3 pr-lg-3">
							<div class="row">
								<div class="col-md-12">
									<div class="mb-1">Provinsi</div>
									<select class="form-control font-size-10 box-purple" v-model="provinsi" @change="selectProv(provinsi)">
										<option v-for="(value, index) in province" :key="index" :value="{ id: value.province_id, text: value.province }">Provinsi {{value.province}}</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="mb-1 mt-3">Kota/Kabupaten</div>
									<select class="form-control font-size-10 box-purple" v-model="kota" @change="selectCity(kota)">
										<option v-for="(value, index) in city" :key="index" :value="{id: value.city_id, text: value.city_name}">{{value.type}} {{value.city_name}}</option>
									</select>
									<div class="invalid-feedback d-block m-0" v-if="errors.city_id"> {{ errors.city_name }} </div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="mb-1 mt-3">Kecamatan</div>
									<select class="form-control font-size-10 box-purple" v-model="kecamatan" @change="selectDistrict(); updateMaps()">
										<option v-for="(value, index) in subdistrict" :key="index" :value="{id: value.subdistrict_id, text: value.subdistrict_name}">Kecamatan {{value.subdistrict_name}}</option>
									</select>
									<div class="invalid-feedback d-block m-0" v-if="errors.subdistrict_id"> {{ errors.subdistrict_id }} </div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="mb-1 mt-3">Alamat Lengkap</div>
									<textarea class="form-control font-size-10 textarea box-purple" rows="3" placeholder="Masukkan Alamat Lengkap" v-model="alamat" @keyup="selectAlamat()" @blur="updateMaps(alamat)"></textarea>
									<div class="invalid-feedback d-block m-0" v-if="errors.address"> {{ errors.address }} </div>
								</div>
							</div>
						</div>
						<div class="order-0 order-lg-1 col-12 col-lg-6 pl-0 pr-0 pl-lg-3 pr-lg-3 box-maps">
							<GmapMap
							:center="{
							lat: location.lat,
							lng: location.lng
						}"
						:zoom="16"
						:options="{
						zoomControl: false,
						mapTypeControl: false,
						scaleControl: false,
						streetViewControl: false,
						rotateControl: false,
						fullscreenControl: false,
						disableDefaultUi: true
					}"
					map-type-id="roadmap"
					style="width: 100%; height: 100%"
					>
					<GmapMarker
					ref="myMarker"
					:position="{
					lat: location.lat,
					lng: location.lng
				}"
				:draggable="true"
				@dragend="updateCoordinates"
				/>
			</GmapMap>
		</div>
	</div>
</div>
</template>
<template v-slot:footer>
	<div class="row">
		<div class="col-10 offset-1 col-md-4 offset-md-2 text-center pt-3 pb-3">
			<button class="btn btn-outline-danger btn-block font-size-10" @click="$refs.updateAlamat.modalHide();">BATAL</button>
		</div>
		<div class="col-10 offset-1 col-md-4 offset-md-0 text-center pt-md-3 pb-3 pb-md-0">
			<button @click="simpan()" class="btn btn-mila btn-block text-white font-size-10 box-purple"><img src="assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
		</div>
	</div>
</template>
</VModal>

<VModal ref="modalProfile">
	<template v-slot:title class="font-size-sm-10">
		Ubah Profile
	</template>
	<template v-slot:body>
		<div class="container-fluid font-size-11 font-size-sm-10 pb-3">
			<form>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1">Nama Mobile Counter</div>
						<input type="text" :readonly="profile.stockist_name != ''" v-model="paramsProfile.name" class="form-control font-size-10 box-purple" @click="getNama()">
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.name"> {{ errorsProfile.name }} </div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1 mt-3">No Handphone</div>
						<input type="text" :readonly="profile.stockist_mobilephone != ''" v-model="paramsProfile.mobilephone" class="form-control font-size-10 box-purple" @click="getTelepon()">
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.mobilephone"> {{ errorsProfile.mobilephone }} </div>
					</div>
					<div class="col-md-12">
						<div class="mb-1 mt-3">No Handphone 2 (Optional)</div>
						<input type="text" v-model="paramsProfile.mobilephone2" class="form-control font-size-10 box-purple" @focus="() => { errorsProfile.mobilephone2 = ''}">
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.mobilephone2"> {{ errorsProfile.mobilephone2 }} </div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1 mt-3">Email</div>
						<input type="text" :readonly="profile.stockist_email != ''" v-model="paramsProfile.email" class="form-control font-size-10 box-purple" @click="getEmail()">
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.email"> {{ errorsProfile.email }} </div>
					</div>
				</div>
			</form>
		</div>
	</template>
	<template v-slot:footer>
		<div class="row">
			<div class="col-10 offset-1 col-md-4 offset-md-2 text-center pt-3 pb-3">
				<button class="btn btn-outline-danger btn-block font-size-10" @click="$refs.modalProfile.modalHide();">BATAL</button>
			</div>
			<div class="col-10 offset-1 col-md-4 offset-md-0 text-center pt-md-3 pb-3 pb-md-0">
				<button @click="updateProfile()" class="btn btn-mila btn-block text-white font-size-10 box-purple"><img src="assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
			</div>
		</div>
	</template>
</VModal>

<VModal ref="modalBank">
	<template v-slot:title class="font-size-sm-10">
		Data Bank
	</template>
	<template v-slot:body>
		<div class="container-fluid font-size-11 font-size-sm-10 pb-3">
			<form>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1">Nama Bank</div>
						<select class="form-control font-size-10 box-purple" v-model="paramsBank.bank_id" @focus="errorsProfile.bank_id = ''">
							<option v-for="(value, index) in optionBank" :key="index" :value="value.bank_id">{{value.bank_name}}</option>
						</select>
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.bank_id"> {{ errorsProfile.bank_id }} </div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1 mt-3">No Rekening</div>
						<input type="text" v-model="paramsBank.account_number" class="form-control font-size-10 box-purple" @focus="errorsProfile.account_number = ''">
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.account_number"> {{ errorsProfile.account_number }} </div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1 mt-3">Nama Pemilik Rekening</div>
						<input type="text" readonly v-model="paramsBank.account_name" class="form-control font-size-10 box-purple" @focus="errorsProfile.account_name = ''">
						<div class="invalid-feedback d-block m-0" v-if="errorsProfile.account_name"> {{ errorsProfile.account_name }} </div>
					</div>
				</div>
			</form>
		</div>
	</template>
	<template v-slot:footer>
		<div class="row">
			<!-- <div class="col-10 offset-1 col-md-4 offset-md-2 text-center pt-3 pb-3">
				<button class="btn btn-outline-danger btn-block font-size-10" @click="$refs.modalBank.modalHide();">BATAL</button>
			</div> -->
			<div class="col-10 offset-1 col-md-4 offset-md-4 text-center pt-md-3 pb-3">
				<button @click="updateBank()" class="btn btn-mila btn-block text-white font-size-10 box-purple"><img src="assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
			</div>
		</div>
	</template>
</VModal>

<VModal ref="modalToko">
	<template v-slot:title>
		Form Tutup Toko Stockist
	</template>
	<template v-slot:body>
		<div class="container-fluid font-size-11 font-size-sm-10 pb-3">
			<form>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1">Waktu Tutup Toko</div>
						<div class="row">
							<div class="col-12 col-md-6 pr-2 pr-md-0">
								<div class="input-group">
									<datepicker :language="indonesia" :disabled-dates="disabledDates" input-class="form-control form-control-sm text-gray box-purple" v-model="toko.start" placeholder="Dari Tanggal" bootstrap-styling @closed="awalToko">
									</datepicker>
									<div class="invalid-feedback d-block m-0" v-if="errorValid.data.start"> {{ errorValid.data.start }} </div>
								</div>
							</div>
							<div class="col-12 col-md-6 pr-md-3">
								<div class="input-group">
									<div class="input-group-prepend rounded-left pl-2 pr-2">
										<div class="background-purple font-size-12 text-white"><i class="far fa-clock mt-2 ml-1 mr-1"></i></div>
									</div>
									<select step="1" v-model = "jamAwal" class="form-control font-size-9 box-purple">
										<option value="">00:00</option>
										<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="mb-1 mt-3">Waktu Buka Toko</div>
						<div class="row">
							<div class="col-12 col-md-6 pr-2 pr-md-0">
								<div class="input-group">
									<datepicker :language="indonesia" :disabled-dates="disabledDates" input-class="form-control form-control-sm text-gray box-purple" v-model="toko.end" placeholder="Sampai Tanggal" bootstrap-styling @closed="akhirToko">
									</datepicker>
									<div class="invalid-feedback d-block m-0" v-if="errorValid.data.end"> {{ errorValid.data.end }} </div>
								</div>
							</div>
							<div class="col-12 col-md-6 pr-md-3">
								<div class="input-group">
									<div class="input-group-prepend rounded-left pl-2 pr-2">
										<div class="background-purple font-size-12 text-white"><i class="far fa-clock mt-2 ml-1 mr-1"></i></div>
									</div>
									<select step="1" v-model = "jamAkhir" class="form-control font-size-9 box-purple">
										<option value="">00:00</option>
										<option :value = 'time' v-for="time in jam" :key="time">{{time}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12">
						<div class="mb-1 mt-3">Alasan Menutup Toko :</div>
						<textarea class="form-control font-size-10 textarea box-purple" rows="3" placeholder="Masukkan Alasan Anda" v-model="toko.reason" @click="reasonToko()"></textarea>
						<div class="invalid-feedback d-block m-0" v-if="errorValid.data.reason"> {{ errorValid.data.reason }} </div>
					</div>
				</div>
			</form>
		</div>
	</template>
	<template v-slot:footer>
		<div class="row">
			<div class="col-10 offset-1 col-md-4 offset-md-2 text-center pt-3 pb-3">
				<button class="btn btn-outline-danger btn-block font-size-10" @click="$refs.modalToko.modalHide();">BATAL</button>
			</div>
			<div class="col-10 offset-1 col-md-4 offset-md-0 text-center pt-md-3 pb-3 pb-md-0">
				<button @click="simpanToko()" class="btn btn-mila btn-block text-white font-size-10 box-purple"><img src="assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
			</div>
		</div>
	</template>
</VModal>

<VModal ref="updateImage">
	<template v-slot:title>
		Ubah Foto Profile
	</template>
	<template v-slot:body>
		<div class="modal-body font-size-11">
			<div class="container-fluid font-size-11 font-size-sm-10">
				<div class="row">
					<div class="col-4 offset-3 col-md-4 offset-md-4">
						<div class="image-frame-m box-shadow">
							<img :src="image" />
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6 offset-3 col-md-4 offset-md-4 text-center pt-2">
						<div class="file-upload btn btn-mila font-size-10 box-purple">
							<span>PILIH FOTO</span>
							<input type="file" ref="inputFile" class="upload text-white" v-on:change="handleFileUpload($event)">
						</div>
					</div>
				</div>
			</div>
		</div>
	</template>
	<template v-slot:footer>
		<div class="row">
			<div class="col-10 offset-1 col-md-4 offset-md-2 text-center pt-3 pb-3">
				<button class="btn btn-outline-danger btn-block font-size-10" @click="$refs.updateImage.modalHide();">BATAL</button>
			</div>
			<div class="col-10 offset-1 col-md-4 offset-md-0 text-center pt-md-3 pb-3 pb-md-0">
				<button @click="upload()" class="btn btn-mila btn-block text-white font-size-10"><img src="assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
			</div>
		</div>
	</template>
</VModal>

<VModal ref="konfirmasiBukaToko">
	<template v-slot:header><div></div></template>
	<template v-slot:body>
		<div class="modal-body p-0">
			<div class="col-12 d-md-flex pl-0">
				<div class="col-5 m-auto pl-0">
					<img class="img-fluid" src="/assets/loading/smile-woman.svg">
				</div>
				<div class="col-7 color-black m-auto">
					<div class="font-bold font-size-sm-10 font-size-11">Konfirmasi Buka Toko</div>
					<div class="font-size-sm-10 font-size-11 pt-2">Apakah Anda yakin ingin membuka toko?</div>
				</div>
			</div>
		</div>
	</template>
	<template v-slot:footer>
		<div class="row">
			<div class="col-12 text-center pb-2">
				<button @click="() => {bukaToko(); $refs.konfirmasiBukaToko.modalHide();}" type="button" class="btn btn-mila font-size-10 pl-4 pr-4 mt-3 ml-3 float-md-right">Buka Sekarang </button>
				<button @click="$refs.konfirmasiBukaToko.modalHide()" type="button" class="btn btn-outline-danger font-size-10 pl-4 pr-4 mt-3 float-md-right">Batal</button>
			</div>
		</div>
	</template>
</VModal>
<VModal ref="suksesCopyLink">
	<template v-slot:header><div></div></template>
	<template v-slot:body>
		<div class="row">
			<div class="col-9 col-md-4 col-lg-4 offset-3 offset-md-0 offset-lg-0">
				<img src="assets/loading/smile-woman.svg">
			</div>
			<div class="col-12 col-md-8 col-lg-8 mt-3 mt-md-0 mt-lg-0 text-center text-md-left">
				<div>
					<span style="font-weight: 600;">Berhasil</span>
				</div>
				<div class="font-size-10 pt-3">
					Tautan berhasil disalin
				</div>
			</div>
		</div>
	</template>
	<template v-slot:footer>
		<div class="row">
			<div class="col-12 text-center pb-2">
				<button @click="$refs.suksesCopyLink.modalHide()" type="button" class="btn btn-mila font-size-10 pl-4 pr-4 mt-3 ml-3 float-md-right">OK</button>
			</div>
		</div>
	</template>
</VModal>
</div>
</template>

<script>
import VModal from '@/components/VModal'
import BtnShareStore from '@/components/BtnShareStore'
import { mapState, mapGetters, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
	name:'Profile',
	components: {
		VModal,
		BtnShareStore,
		Datepicker,
	},
	data: () =>({
		disabledDates: { to: new Date(Date.now() - 8640000) },
		formData: {},
		file: '',
		provinsi: {},
		kota: {},
		kecamatan: {},
		alamat: {},
		jamAwal: '00:00:00',
		jamAkhir: '00:00:00',
		toko: {
			start: '',
			end: '',
			reason: '',
		},
		update: {
			address: '',
			province_id: '',
			province_name: '',
			city_id: '',
			city_name: '',
			subdistrict_id: '',
			subdistrict_name: '',
		},
		paramsProfile: {
			name: '',
			mobilephone: '',
			email: '',
			address: '',
		},
		paramsBank: {
			bank_id: '',
			account_number: '',
			account_name: '',
			account_branch: '',
		},
		paramsUpload: {
			code: '',
			image: '',
		},
		image: '',
		params: [],
		defaultJam: {
			open : '08:00',
			close : '17:00'
		}
	}),
	computed: {
		...mapState('profileList', ['profile', 'province', 'city', 'subdistrict', 'errors', 'errorsProfile', 'errorValid', 'bank', 'scedule', 'jam', 'optionBank']),
		...mapState('maps', ['location']),

		...mapGetters('auth', ['isAuth']),
		...mapState('auth', ['userData']),
		validasiMsg() {
			return this.errorValid.message
		},
		showChangeProfile() {
			// return this.profile.stockist_name == '' ||  this.profile.stockist_mobilephone == '' || this.profile.stockist_email == ''
			return false
		},
		showEditBank() {
			return false
		},
		showEditAddress() {
			return false
		},
	},
	methods: {
		...mapActions('profileList', ['getProvince', 'getCity', 'getSubdistrict', 'submit', 'submitProfile', 'submitToko', 'bukaToko', 'uploadImage', 'getBank', 'getScedule', 'updateScedule', 'submitBank', 'getOptionBank']),
		...mapActions('maps', ['postGeolocation', 'getMaps']),

		ubahJadwalToko(val) {
			if(this.scedule[val].length == 0 ) {
				this.scedule[val] = this.defaultJam
			} else {
				this.scedule[val] = []
			}
			this.updateScedule(this.scedule)
		},
		ubahFoto() {
			this.image = this.profile.stockist_image
			this.$refs.updateImage.modalShow();
		},
		handleFileUpload(event) {
			this.formData = new FormData();
			this.formData.append('code', this.profile.stockist_code);
			this.formData.append('image', event.target.files[0]);
			var files = event.target.files || event.dataTransfer.files;

			if (!files.length)
				return;

			this.createImage(files[0]);
		},
		createImage(file) {
			var reader = new FileReader();
			var vm = this;

			reader.onload = (e) => {
				vm.image = e.target.result;
			};
			reader.readAsDataURL(file);
		},
		upload() {
			var that = this
			this.uploadImage(this.formData).then(() => {
				that.$refs.updateImage.modalHide();
			});
		},
		tutupToko() {
			this.$refs.modalToko.modalShow();
		},
		konfirmasiBuka() {
			this.$refs.konfirmasiBukaToko.modalShow();
		},
		simpanToko() {
			this.toko.start = moment(this.toko.start).format('YYYY-MM-DD')
			this.toko.end = moment(this.toko.end).format('YYYY-MM-DD')

			if(this.jamAwal.length <= 5) {
				this.jamAwal = this.jamAwal+':00'
			}
			if(this.jamAkhir.length <= 5) {
				this.jamAkhir = this.jamAkhir+':00'
			}
			this.toko.start = this.toko.start + ' '+ this.jamAwal

			this.toko.end = this.toko.end + ' ' + this.jamAkhir
			this.submitToko(this.toko)
		},
		reasonToko() {
			this.errorValid.data.reason = ''
		},
		akhirToko() {
			this.errorValid.data.end = ''
		},
		awalToko() {
			this.errorValid.data.start = ''
		},
		UbahProfile() {
			this.$refs.modalProfile.modalShow();
			this.paramsProfile.name = this.profile.stockist_name
			this.paramsProfile.mobilephone = this.profile.stockist_mobilephone
			this.paramsProfile.mobilephone2 = this.profile.stockist_mobilephone2
			this.paramsProfile.email = this.profile.stockist_email
			this.paramsProfile.address = this.profile.stockist_origin_address
		},
		UbahBank() {
			this.$refs.modalBank.modalShow();
			this.paramsBank.bank_id = this.bank.bank_id
			this.paramsBank.account_name = this.bank.account_name
			this.paramsBank.account_number = this.bank.account_number
			this.paramsBank.account_branch = ''
		},
		getNama() {
			this.errorsProfile.name = ''
		},
		getTelepon() {
			this.errorsProfile.mobilephone = ''
		},
		getEmail() {
			this.errorsProfile.email = ''
		},
		getAlamat() {
			this.errorsProfile.address = ''
		},
		updateBank() {
			this.submitBank(this.paramsBank).then(() => {
				this.$refs.modalBank.modalHide()
			})
		},
		updateProfile() {
			this.submitProfile(this.paramsProfile)

			if(this.paramsProfile.name && this.paramsProfile.mobilephone && this.paramsProfile.email && this.paramsProfile.address) {
				this.$refs.modalProfile.modalHide()
			} else {
				this.$refs.modalProfile.modalShow()
			}
		},
		ubahAlamat() {
			this.postGeolocation({
				lat: parseFloat(this.profile.stockist_latitude),
				lng: parseFloat(this.profile.stockist_longitude)
			})
			this.$refs.updateAlamat.modalShow();
			this.getProvince()
			this.provinsi = { id:this.profile.stockist_origin_province_id, text:this.profile.stockist_origin_province_name }
			this.getCity(this.profile.stockist_origin_province_id)
			this.kota = { id:this.profile.stockist_origin_city_id, text:this.profile.stockist_origin_city_name }
			this.getSubdistrict(this.profile.stockist_origin_city_id)
			this.kecamatan = { id: this.profile.stockist_origin_subdistrict_id, text:this.profile.stockist_origin_subdistrict_name }
			this.alamat = this.profile.stockist_origin_address
		},
		selectProv(val) {
			this.kota = '',
			this.kecamatan = '',
			this.getCity(val.id)
			this.errors.province_id = ''
		},
		selectCity(val) {
			this.getSubdistrict(val.id)
			this.errors.city_id = ''
		},
		selectDistrict() {
			this.errors.subdistrict_id = ''
		},
		selectAlamat() {
			this.errors.address = ''
		},
		updateMaps(address = null) {
			this.getMaps((address ? address + ', ' : '') + this.kecamatan.text + ', ' + this.kota.text + ', ' + this.provinsi.text)
		},
		simpan() {
			this.update.province_id = this.provinsi.id
			this.update.province_name = this.provinsi.text
			this.update.city_id = this.kota.id
			this.update.city_name = this.kota.text
			this.update.subdistrict_id = this.kecamatan.id
			this.update.subdistrict_name = this.kecamatan.text
			this.update.address = this.alamat
			this.update.lat = this.location.lat
			this.update.lng = this.location.lng
			this.submit(this.update)

			if(this.provinsi && this.kota && this.kecamatan && this.alamat) {
				this.$refs.updateAlamat.modalHide()
				this.provinsi = ''
				this.kota = ''
				this.kecamatan = ''
				this.alamat = ''
			} else {
				this.$refs.updateAlamat.modalShow()
			}
		},
		updateCoordinates(location) {
			this.postGeolocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		cekBank() {
			if(!this.bank.bank_id) {
				this.getOptionBank()
				let name = this.profile.stockist_name ? this.profile.stockist_name : this.userData.stockist_name
				this.paramsBank.account_name = name
				this.$refs.modalBank.modalShow();
			}
		},
	},
	created() {
		this.image = this.profile.stockist_image
		this.getScedule()
		this.$store.dispatch('setPageTitle', `Profil`);
	},
	mounted() {
		this.getBank().then(() => {
			this.cekBank()
		})
	},
	watch: {
		validasiMsg: function() {
			if(this.validasiMsg == 'Berhasil') {
				this.$refs.modalToko.modalHide()
				this.toko.end = ''
				this.toko.start = ''
				this.toko.reason = ''
				this.jamAwal = ''
				this.jamAkhir = ''
				this.jamAwal = '00:00:00'
				this.jamAkhir = '00:00:00'
				return
			}
		},
	}
}
</script>

<style>
.switch-sm {
	width: 40px;
	height: 16px;
}
.switch-sm .slider:before {
	height: 10px;
	width: 10px;
	left: 2px;
	bottom: 3px;
}
.image-frame {
	width: 90px;
	height: 90px;
	border-radius: 50%;
	overflow: hidden;
}
.image-frame-m {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	overflow: hidden;
}
.image-frame img, .image-frame-m img {
	width: 8em;
	height: 8em;
	object-fit: cover;
	object-position: center;
}
.file-upload {
	position: relative;
	overflow: hidden;
	margin: 10px;
	width: 100px;
	margin-left: 0;
}
.file-upload input.upload {
	position: absolute;
	top: 0;
	right: 0;
	margin: 0;
	padding: 0;
	cursor: pointer;
	opacity: 0;
	filter: alpha(opacity=0);
	height: 40px;
}
.input-group-prepend {
	background-color: #c96dd8;
	border-top-left-radius: 0.25rem !important;
	border-bottom-left-radius: 0.25rem !important;
}
.input-group-text {
	background-color: #c96dd8;
}
.btn-batal {
	left: 2em;
}
.vdp-datepicker input {
	background-color: #ffffff!important;
}
.vdp-datepicker {
	width: 100%;
	margin-right: 8px;	
}
.mh-210 {
	min-height: 210px;
}

@media (max-width: 425px) {
	.vdp-datepicker {
		padding-bottom:8px;
	}
}

@media (min-width: 414px) and (max-width: 450px) {
	.image-frame-m {
		margin-left: .5em;
	}
}

@media (min-width: 320px) and (max-width: 450px) {
	.vdp-datepicker__calendar:nth-child(2), .vdp-datepicker__calendar:nth-child(3), .vdp-datepicker__calendar:nth-child(4) {
		width: 243px !important;
		margin-left: 0 !important;
	}
	.image-frame {
		width: 80px;
		height: 80px;
	}
	.mh-210 {
		min-height: 0 !important;
	}
}
</style>